<template lang="pug">
  el-dialog(
    width="55%"
    title="Select Question Library"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    @close="$emit('formCancelClicked')"
    center
  )
    el-row(:gutter="15")
      el-col.padding-top-15(
        :span="12"
        v-for="(value, key) in LIBRARY_TYPES"
        :key="key"
        align="center"
      )
        el-button(
          class="libraryBtn"
          @click="chooseType(key)"
        )
          img(
            class="typeImg"
            :src="typeImgSrc(key)"
          )

        p(class="typeName") {{ key.charAt(0).toUpperCase() + key.slice(1) + ' Library'}}
    
    el-row.margin-top-30
</template>

<script>
  import {LIBRARY_TYPES, LIBRARY_TYPES_LABELS} from '@/defines/constants'

  export default {
    name: 'LibrarySelectorModal',

    props: {
      visibleProp: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        LIBRARY_TYPES,
        LIBRARY_TYPES_LABELS,
      }
    },

    computed: {
      visible: {
        get() {
          return this.visibleProp
        },

        set(value) {
          if (value === false) {
            this.$emit('close')
          }
        },
      },
    },

    methods: {
      chooseType(type) {
        this.$emit('selectLibrary', type)
        this.visible = false
      },

      /* eslint-disable */
      typeImgSrc(type) {
        return require(`@/assets/LibraryTypes/${type}_library.svg`)
      },
      /* eslint-enable */
    },
  }
</script>

<style scoped>
  .libraryBtn {
    border-radius: 20px;
    height: 120px;
    padding: 0px;
    border: none;
  }


  .typeName {
    color: #00a8ff;
    font-size: 1.35em;
    line-height: 1.35em;
  }

  .typeImg {
    height: 100%;
  }

  .typeImg:hover {
    filter: brightness(0.7) sepia(1) hue-rotate(180deg) saturate(3);
  }

</style>

